(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/views/footer/footer-items.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/views/footer/footer-items.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.product_start_page=_svs.app.product_start_page||{};
_svs.app.product_start_page.templates=_svs.app.product_start_page.templates||{};
svs.app.product_start_page.templates.footer_items = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"row\">\n\n</div>\n";
},"useData":true});
Handlebars.partials['components-app-product_start_page-footer_items'] = svs.app.product_start_page.templates.footer_items;
})(svs, Handlebars);


 })(window);